import { CssBaseline, ThemeProvider } from '@mui/material';
import * as Sentry from '@sentry/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { Auth0ProviderWithNavigate } from './modules';
import { useCookieConsent } from './modules/cookie-consent/useCookieConsent';
import { ImpersonateControl } from './modules/ImpersonateControl';
import { SentryFallbackRender } from './pages/error/SentryFallback';
import { AppRouter } from './router';
import { theme } from './style/theme';
import { NotificationsProvider } from './utils/notification';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retryDelay: 300,
      // don't set retry to 0 as at least 1 retry is needed for access token renewal -- see api/fetcher/useFetch.ts for more info
    },
  },
});

function App() {
  useCookieConsent();

  return (
    <Sentry.ErrorBoundary fallback={SentryFallbackRender}>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <NotificationsProvider />
          <BrowserRouter>
            <Auth0ProviderWithNavigate>
              <AppRouter />
              <ImpersonateControl />
            </Auth0ProviderWithNavigate>
          </BrowserRouter>
        </ThemeProvider>
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  );
}

export default App;
